import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';

const ParkProposition = ({ label, item, handleValue, parkProp }) => {
  const setObj = {
    checkboxVal: '',
    inputVal: '',
  };
  const [obj, setData] = useState(setObj);

  const handleSubmitData = () => {
    let objArray = {};
    let scope_of_partnership = [];
    if (obj === '') {
      return false;
    } else {
      if (item?.id?.toLowerCase() === 'strategic') {
        if (obj?.inputVal.length > 0) {
          objArray = {
            ...objArray,
            strategic: obj.inputVal,
          };
        } else {
          objArray = {};
        }
      }
      if (item?.id?.toLowerCase() === 'outreach') {
        objArray = {
          ...objArray,
          outreach: obj.inputVal,
        };
      }
      if (item?.id?.toLowerCase() === 'revenue') {
        objArray = {
          ...objArray,
          revenue: obj.inputVal,
        };
      }
      if (item?.id === 'strengthening_bottom_lines') {
        objArray = {
          ...objArray,
          strengthening_bottom_lines: obj.inputVal,
        };
      }
      if (item?.id === 'pushing_the_top_line') {
        objArray = {
          ...objArray,
          pushing_top_line: obj.inputVal,
        };
      }
      if (obj.checkboxVal === true) {
        let other = null;
        if (item?.id?.toLowerCase() === 'other with remark') {
          other = obj.inputVal;
        }
        scope_of_partnership = item.id;
      }
    }
    let proposition_for_park_plus = [objArray];
    if (obj?.checkboxVal && parkProp) {
      if (
        proposition_for_park_plus[0] !== '' &&
        Regex.text.test(obj.inputVal)
      ) {
        handleValue({
          proposition_for_park_plus,
          scope_of_partnership,
        });
      } else {
        handleValue('');
      }
    } else {
      handleValue('');
    }
    if (obj?.checkboxVal && !parkProp) {
      handleValue({
        proposition_for_park_plus,
        scope_of_partnership,
      });
    }
  };
  useEffect(() => {
    handleSubmitData();
  }, [obj]);
  return (
    <Fragment>
      <Checkbox
        label={label}
        type="checkbox"
        errorMsg={localization.isRequired}
        onChange={(val) => {
          setData({ ...obj, checkboxVal: val });
        }}
        required
      />
      <label className="error date_error">{localization.isRequired}</label>

      {(parkProp && obj.checkboxVal === true) ||
      (item.id === 'Other with remark' && obj.checkboxVal === true) ? (
        <ConstantInput
          label=""
          regex={Regex.text.test(obj.inputVal)}
          errorMsg={
            obj.inputVal === ''
              ? localization.isRequired
              : localization.requiredCharacter
          }
          type="text"
          handleChange={(val) => setData({ ...obj, inputVal: val })}
          required
          isStarRequired={true}
        />
      ) : null}
    </Fragment>
  );
};

ParkProposition.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  item: PropTypes.any,
  handleValue: PropTypes.func,
  parkProp: PropTypes.bool,
};

export default ParkProposition;
